import { FlexBox, FInter } from "@brg/ui";
import styled, { css } from "styled-components";
import { LayoutConst } from "core/modules";

export const Outer = styled(FlexBox)<{ shifted?: boolean, isAgeytomesh?: boolean, logoLength?: number }>`
  max-width: 300px;
  // margin-right: ${({ isAgeytomesh }) => isAgeytomesh ? '32px' : 0};
  position: relative;
   left: ${(p) => p?.shifted ? `-${p?.logoLength}px` : 0};
  transition: all 500ms;
`;

export const PrefixName = styled(FlexBox)<{ isMobile?: boolean, disableOffset?: boolean }>`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: ${p => p.isMobile ? '22px' : '28px'};
    color: ${(p) => p.theme.navigationBar.logoPrefixName };
    position: relative;
    top: ${({ disableOffset }) => disableOffset ? 0 : '2px'};
    white-space: nowrap;
    letter-spacing: -0.03em;

    @media(max-width: 1600px) {
        top: 1px;
        font-size: 17px;
        line-height: 22px;
    }
`;

export const LogoName = styled(FlexBox)<{isMobile?: boolean, red?: boolean, importantColor?: string }>`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: ${p => p.isMobile ? '22px' : '28px'};
    color: ${(p) => p?.red ? '#FF0000' : p?.importantColor ? p?.importantColor : p.theme.navigationBar.logoName};
    position: relative;
    top: 0px;
    white-space: nowrap;
    letter-spacing: -0.03em;
`;

export const Burger = styled(FlexBox)`
    height: 40px;
    align-items: center;
    opacity: 0.73;
    transition: all 0.2s;

    &:hover {
        opacity: 1;
    }
    ${FlexBox} {
        @media(max-width: ${LayoutConst.screen.sm}px) {
            margin-right: 10px; /* важно, изменения для всего сайта */
        }
    }
`;

export const PostFixWrapper = styled(FlexBox)`
    padding-top: 3px;

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     padding-top: 0px;
    // }
`;

export const PostFixName = styled(FInter.TextBold)<{isMobile?: boolean}>`
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: 28px;
    color: #C7D332;

    @media(max-width: 1600px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

export const LogoWrapper = styled(FlexBox)<{ visiblePopUp?: boolean }>`
    flex-flow: row;

    ${({ visiblePopUp }) => visiblePopUp ? css`

    .burger-wrapper {
        padding-top: 3px;
        svg path {
            fill: #909090;
            stroke: #909090;
        }

        svg rect {
            stroke: #909090;
        }
    }
    ` : css`
        .burger-wrapper {
            padding-top: 8px;
        }
    `};
`;import { FlexBox, FInter } from "@brg/ui";
import styled, { css } from "styled-components";
import { LayoutConst } from "core/modules";

export const Outer = styled(FlexBox)<{ shifted?: boolean, isAgeytomesh?: boolean, logoLength?: number }>`
  max-width: 300px;
  // margin-right: ${({ isAgeytomesh }) => isAgeytomesh ? '32px' : 0};
  position: relative;
   left: ${(p) => p?.shifted ? `-${p?.logoLength}px` : 0};
  transition: all 500ms;
`;

export const PrefixName = styled(FlexBox)<{ isMobile?: boolean, disableOffset?: boolean }>`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: ${p => p.isMobile ? '22px' : '28px'};
    color: ${(p) => p.theme.navigationBar.logoPrefixName };
    position: relative;
    top: ${({ disableOffset }) => disableOffset ? 0 : '2px'};
    white-space: nowrap;
    letter-spacing: -0.03em;

    @media(max-width: 1600px) {
        top: 1px;
        font-size: 17px;
        line-height: 22px;
    }
`;

export const LogoName = styled(FlexBox)<{isMobile?: boolean, red?: boolean, importantColor?: string }>`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: ${p => p.isMobile ? '22px' : '28px'};
    color: ${(p) => p?.red ? '#FF0000' : p?.importantColor ? p?.importantColor : p.theme.navigationBar.logoName};
    position: relative;
    top: 0px;
    white-space: nowrap;
    letter-spacing: -0.03em;
`;

export const Burger = styled(FlexBox)`
    height: 40px;
    align-items: center;
    opacity: 0.73;
    transition: all 0.2s;

    &:hover {
        opacity: 1;
    }
    ${FlexBox} {
        @media(max-width: ${LayoutConst.screen.sm}px) {
            margin-right: 10px; /* важно, изменения для всего сайта */
        }
    }
`;

export const PostFixWrapper = styled(FlexBox)`
    padding-top: 3px;

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     padding-top: 0px;
    // }
`;

export const PostFixName = styled(FInter.TextBold)<{isMobile?: boolean}>`
    font-size: ${p => p.isMobile ? '17px' : '22px'};
    line-height: 28px;
    color: #C7D332;

    @media(max-width: 1600px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

export const LogoWrapper = styled(FlexBox)<{ visiblePopUp?: boolean }>`
    flex-flow: row;

    ${({ visiblePopUp }) => visiblePopUp ? css`

    .burger-wrapper {
        padding-top: 3px;
        svg path {
            fill: #909090;
            stroke: #909090;
        }

        svg rect {
            stroke: #909090;
        }
    }
    ` : css`
        .burger-wrapper {
            padding-top: 8px;
        }
    `};
`;